<div class="image-cell-wrapper">
    <div class="image-container">
        <img [src]="data.thumbnailLink" />
    </div>
    <div class="image-details-container">
        <div class="info-container">
            <span class="title">{{ ('visuals.visualsTab.imageTracker.table.assetTooltip.assetIndex' | translate) + ':' }}</span>
            <span>{{ data.assetIndex }}</span>
        </div>
        <div class="info-container">
            <span class="title">{{ ('visuals.visualsTab.imageTracker.table.assetTooltip.publicMediaId' | translate) + ':' }}</span>
            <span>{{ data.publicMediaId }}</span>
        </div>
        <div class="info-container">
            <span class="title">{{ ('visuals.visualsTab.imageTracker.table.assetTooltip.caption' | translate) + ':' }}</span>
            <span class="wrap">{{ data.mediaCaption }}</span>
        </div>
    </div>
</div>
